/**
 * Get a string of classes from a class and an array of modifiers
 * @param {string} className
 * @param {array} modifiers
 * @returns {string}
 */
export const getClassNames = (className, modifiers = []) =>
  [className, ...modifiers.filter(Boolean).map((modifier) => `${className}--${modifier}`)].filter(Boolean).join(' ');

/**
 * Get an array of valid classes from a string (i.e. it is useful for getting an array of modifiers)
 * @param {string} className
 * @returns {array}
 */
export const splitClassName = (className) => className.split(' ').filter(Boolean);
